var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doctor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21c0 0.547-0.453 1-1 1s-1-0.453-1-1 0.453-1 1-1 1 0.453 1 1zM22 21.953c0 2.547-1.672 4.047-4.172 4.047h-13.656c-2.5 0-4.172-1.5-4.172-4.047 0-3.109 0.625-8.016 4.344-8.828-0.25 0.594-0.344 1.234-0.344 1.875v3.172c-1.203 0.422-2 1.563-2 2.828 0 1.656 1.344 3 3 3s3-1.344 3-3c0-1.266-0.812-2.406-2-2.828v-3.172c0-0.516 0.047-1.031 0.391-1.453 1.313 1.031 2.938 1.625 4.609 1.625s3.297-0.594 4.609-1.625c0.344 0.422 0.391 0.938 0.391 1.453v1c-2.203 0-4 1.797-4 4v1.391c-0.313 0.281-0.5 0.688-0.5 1.109 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.422-0.187-0.828-0.5-1.109v-1.391c0-1.094 0.906-2 2-2s2 0.906 2 2v1.391c-0.313 0.281-0.5 0.688-0.5 1.109 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.422-0.187-0.828-0.5-1.109v-1.391c0-1.422-0.766-2.75-2-3.453 0-1.141 0.109-2.359-0.344-3.422 3.719 0.812 4.344 5.719 4.344 8.828zM17 8c0 3.313-2.688 6-6 6s-6-2.688-6-6 2.688-6 6-6 6 2.688 6 6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.e3745095c4c85d51804c4739d0aee643.svg";
export { ForwardRef as ReactComponent };